import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const Title = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: 1fr 5fr;
	grid-auto-rows: minmax(40px, auto);
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
	white-space: nowrap;
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #01337d;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		align-items: center;
	}
	&.min-height-ul {
		min-height: 12.6rem;
	}
	&.min-height {
		min-height: 5.2rem;
	}
	li {
		position: relative;
		padding-left: 1.3rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 3px);
			left: 0;
			background-color: currentColor;
			width: 3px;
			height: 3px;
			border-radius: 50%;
		}
	}
`;

export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;

export const SubTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const DescriptionBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const Description = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
